import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { GameNavComponent } from 'src/app/modules/layouts/components/game-nav/game-nav.component';
import { MobilePageHeaderComponent } from 'src/app/modules/user/components/mobile-page-header/mobile-page-header.component';

@Component({
  selector: 'fgb-predictor-layout-page',
  standalone: true,
  imports: [GameNavComponent, RouterModule, FGBSharedModule, DirectivesModule, PipesModule, MobilePageHeaderComponent],
  templateUrl: './predictor-layout-page.component.html',
  styleUrl: './predictor-layout-page.component.scss',
})
export class PredictorLayoutPageComponent {}
